import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const languages = {
    'pt-BR': {
        components:{
            AcceptTerms:{
                accept: ["Li e compreendo", "os termos acima", "próximo"],
            },
            Alerts:{
                AlertAnswer:{
                    subtitle: 'Inseriu a resposta correta!',
                    titleStep: [
                        'Dinheiro inicial', 'Tentativas', 'Resolução da equação', 'Resposta correta', 'mais uma chance', 'Resposta correta', 'Total:'
                    ],
                    typeExtract: ['Tempo Esgotado', 'Grana Esgotada', 'Resposta correta!'],
                    button: 'prosseguir'
                },
                AlertCorrect:{
                    title: 'Resposta Correta!',
                    subtitles: ['Inseriu a resposta correta!', 'Para concluir o Game, você precisa avaliar os participantes do seu grupo.'],
                    button: 'Avaliar'
                },
                AlertFeedback: {
                    textButton: 'vamos lá',
                    infoDefault:{
                        smallTitle: 'Gostaríamos de saber',
                        title: 'sua opinião',
                        desc: 'Para nós, é muito importante saber o que você achou, assim conseguimos deixar a experiência cada vez melhor. É rapidinho, são só 2 minutinhos.',
                    }
                },
                AlertFinal:{
                    title: 'Jogo concluído!',
                    subtitle: 'O seu resultado será processado dentro de alguns dias e você será avisado no e-mail cadastrado. Obrigado! :)',
                    textButton: 'Ok!'
                },
                AlertGlobal:{
                    textButton: 'Entendi'
                },
                AlertMatchMaking:{
                    title: ['O game está prestes a começar, faltam ', ' minutos para iniciar. '],
                    subtitle: ['Não esqueça de assistir o ', 'vídeo', ' e ler as ', 'regras!'],
                    textButton: 'Ok!'
                },
                AlertSchedule:{
                    message: ['Sessão agendada para ', 'às'],
                    title: 'Acesse com antecedência',
                    ruleMessages: ['A sala de espera se abre ', ' 10 minutos', 'antes do horário marcado.', 'Não se atrase!', 'Temos uma tolerância de apenas ', '10 minutos ', 'após o início do jogo.'],
                    textButton: 'Ok'
                },
                AlertTeamFinish:{
                    title: ['tempo', 'dinheiro', 'esgotado!'],
                    desc: 'Para concluir o Game, você precisa avaliar os participantes do seu grupo.',
                    textButton: 'avaliar!'
                }
            },
            Dashboard:{
                SessionList: {
                    timestampAlert: '* Horário de Brasília',
                    emptySessions: {
                        title: 'Sessões esgotadas!',
                        subtitle: 'As sessões estão esgotadas. Entre em contato com a empresa responsável pelo processo seletivo.'
                    }
                }
            },
            feedback:{
                HeaderFeedback: {
                    descProgress: '% completo'
                }
            },
            EnigmaToggle:{
                EnigmaBody:{
                    textButton: 'Sugerir resposta'
                },
                EnigmaHeader:{
                    suggestion: 'nova sugestão'
                },
                EnigmaSugestion:{
                    rule: 'Lembre-se que o resultado dos enigmas é numérico e as sugestões gratuitas. Nada será debitado do dinheiro do grupo',
                    placeholder: 'Digite a sua sugestão',
                    textButton: ['Enviar', 'Voltar'],
                    toasterTexts: ['Resposta vazia', 'Sugestão enviada.', 'Sugestão não enviada']
                }
            },
            PageSlider:{
                SlideContent:{
                    rightTitle: 'sair',
                    loader:{
                        message: 'Aguarde enquanto estamos processando seu resultado'
                    }
                }
            },
            Report:{
                ChartRadar:{
                    labels: ['Cooperador', 'Participativo', 'Espontâneo', 'Ágil', 'Intenso', 'Coordenador', 'Ouvinte', 'Planejador', 'Investigador', 'Amistoso'],
                    datasets: {
                        label: 'Você'
                    }
                },
                Competences:{
                    accordionDataGroup:[
                        'iniciativa',
                        'Papel no time',
                        'Processo',
                        'Entrega',
                        'Interação',
                    ],
                    accordionDataTitle:[
                        'Cooperador',
                        'Coordenador',
                        'Participativo',
                        'Ouvinte',
                        'Espontâneo',
                        'Planejador',
                        'Ágil',
                        'Investigador',
                        'Intenso',
                        'Amistoso'
                    ],
                    accordionText: [

                        'Durante o game você procurou seguir a estratégia definida pela equipe e ajudar os demais membros do grupo ao invés de buscar um posicionamento de coordenação e direção dos colegas.',
                        'Durante o game você procurou coordenar o grupo, sugerindo estratégias e apontando possíveis direções a serem seguidas.',

                        'Você se mostrou bastante participativo, apresentando um grande volume de interações com o grupo.',
                        'Você apresentou baixo volume de interações, abaixo da média, atuando mais como ouvinte e palpitando de vez em quando.',

                        'No decorrer do game você apresentou um estilo mais espontâneo,  autônomo e tomando suas próprias decisões. Mais independente do grupo.',
                        'No decorrer do game você apresentou um estilo planejado e orquestrado com os demais, analisando o conteúdo e palpitando junto aos colegas.',

                        'Durante as discussões do grupo foi possível perceber que você buscou a praticidade e a conclusão em menor tempo ao invés de questionar e se aprofundar nos assuntos em questão.',
                        'Durante as discussões do grupo foi possível perceber que você questionou os colegas e buscou se aprofundar no assunto em questão ao invés de buscar concluir em menor prazo.',

                        'Na interação com os colegas você demonstrou intensidade e sentimentos claros em sua fala, expressando-se abertamente sobre o que pensava no momento.',
                        'Na interação com os colegas você se mostrou ponderado e amigável ao invés de aprensentar uma comunicação intensa e abrasiva.'
                        
                    ]                   
                }
            },
            Rules:{
                backOption: 'Sala de espera',
                title: 'Regras',
                rules: [
                    'IMPORTANTE!', 
                    'Não estamos testando conhecimento', 
                    ' ! Por isso, você poderá ', 
                    'pesquisar à vontade', 
                    ' para encontrar as respostas', 
                    'Cada participante começa com ',
                    '$3 mil;',
                    'Para cada tentativa final (resposta da fórmula), cada candidate pagará ',
                    '$1 mil;',
                    'Acertando a resposta final, ganhará ',
                    '$15 mil',
                    ', e os',
                    'demais',
                    ' do grupo ganham ', 
                    '$8 mil;',
                    'Não perde pontos',
                    ' para fazer tentativas nos 3 enigmas, mas não sabe se as respostas estão corretas;',
                    'O jogo termina quando ',
                    'esgota o dinheiro de todos',
                    'por tempo ',
                    'ou ',
                    'quando alguém acerta'
                ],
                buttonText: ['Ver regras', 'Video de regras', 'Chat']
            }
        },
        containers:{
            FeedbackContainer:{
                textButton: 'Vamos lá',
                smallTitle: 'Gostaríamos de saber',
                title: 'sua opinião',
                desc: 'Para nós, é muito importante saber o que você achou, assim conseguimos deixar a experiência cada vez melhor. É rapidinho, são só 2 minutinhos.',
            },
            ReportContainer:{
                alert: {
                    title: 'Pera aí!',
                    subtitle: 'Para que seu resultado seja enviado você deve avançar até a última tela do relatório'
                }  
            }
        },
        store:{
            outputChatMessages:[
                'Olá! Você está participando do Decode Game!  (que já já vai começar) ',
                'Esse reloginho que está aparecendo no cantinho da tela é o tempo que falta para o início do jogo. Esse é o tempo limite para os participantes dessa sessão entrarem  no jogo.',
                'Enquanto isso, para não perdermos tempo, vou te mandar um vídeo com as regras do game:',
                `Ou, se preferir, segue um resumo delas logo abaixo:
                Você e seus colegas precisarão encontrar as respostas de 3 enigmas (A, B e C) e depois resolver uma EQUAÇÃO FINAL utilizando esses resultados.
                Cada participante começa com $3.000 na conta.
                Cada tentativa na EQUAÇÃO FINAL custa $1.000 e sai diretamente da conta de candidate que fez a tentativa.
                O jogador que inserir a resposta correta da EQUAÇÃO FINAL recebe $15.000 de prêmio e os demais integrantes do grupo recebem $8.000 cada um.
                Vocês podem fazer sugestões de respostas para cada enigma. Isso não tem custos e vocês podem fazer quantas sugestões quiserem. (isso não mostra se a resposta está correta)
                O jogo termina quando o dinheiro de todos se esgota, quando os 30 minutos se acabam ou quando alguém insere a resposta correta na EQUAÇÃO FINAL`,
                'IMPORTANTE!  Não estamos testando conhecimento! Por isso, você poderá pesquisar a vontade para encontrar as respostas :)',
                'Avisaremos a cada novo integrante que entrar no grupo e você também poderá acompanhar quais são os integrantes do seu grupo clicando na setinha, na parte superior da tela.'
            ],
            rulesVideoUrl: '<iframe width="250px" height="auto" src="https://www.youtube.com/embed/kqSw6z7wACQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        },
        views: {
            RedirectExternal: {
                alertError1: 'Desculpe, houve um erro ao com a URL',
                alertError2: 'Erro com a url, entre em contato com a empresa responsável pelo processo seletivo',
                alertError3: 'Você está tentando acessar o processo seletivo fora do período',
            },
            AcceptReport:{
                acceptData:{
                    titles: ['Limite de responsabilidade', 'Elegibilidade', 'Metodologia'],
                    paragraphs: [
                        'A Huddle não tem a intenção e nem o interesse de estabelecer um perfil psicológico ou comportamental permanente/definitivo das pessoas que passam pelo nosso método de Seleção por Performance.',
                        'Assim sendo, compreendemos que cada indivíduo é muito complexo e deve ser analisado por diversas abordagens complementares à nossa ferramenta, como dinâmicas em grupo, painéis de apresentação e entrevistas por competência.',
                        'Enfatizamos que os insights gerados por meio das nossas ferramentas devem ser complementados por outros dados, não devendo ser a fonte exclusiva e sobrepondo conclusões geradas por outras abordagens de avaliação.',
                        'A escolha dos participantes que seguirão nas etapas seguintes do processo seletivo é inteiramente realizada pelos avaliadores e recrutadores da organização.',
                        'Toda comunicação com candidates é de inteira responsabilidade da empresa contratante e nós não detemos a lista de aprovados e reprovados na própria etapa que conduzimos. Também não exercemos nenhum controle ou influência sobre esta decisão.',
                        'Assim sendo, reiteramos que não emitimos nenhum informativo para candidates sobre sua continuidade, ou não, no processo seletivo.',
                        'Utilizamos como referência o estudo realizado pela TTI Success International™, que contempla 23 competências consideradas universais para as empresas. Filtramos e agrupamos essas competências, conectando-as com a realidade de um cargo de início de carreira e também com aquilo que é possível ser analisado durante o jogo.'
                    ]
                }
            },
            Dashboard:{
                steps:{
                    finished:[
                        'Concluido', 'Você não pode reagendar após ter finalizado o game.', 'Concluido', 'Você não pode mais jogar após ter finalizado o game.', 'relatório','O seu relatório ainda não foi processado.'
                    ],
                    expired:[
                        'Reagendar',
                        'Escolha um novo dia e um novo horário para realizar o jogo',
                        'Sessão expirada',
                        'Infelizmente, você excedeu o tempo de tolerância :(',
                        'Relatório',
                        'Você precisa terminar o game para ver o seu resultado',
                    ],
                    started:[
                        'Reagendar',
                        'Sessão agendada para',
                        ' às ',
                        'horário de brasilia',
                        'Entrar',
                        'Você poderá acessar o game até às ',
                        'horário de brasilia',
                        'relatório',
                        'Você precisa terminar o game para ver o seu resultado',
                    ],
                    inProgress:[
                        'Reagendar',
                        'Sessão agendada para',
                        ' às ',
                        'horário de brasilia',
                        'Entrar',
                        'O seu game está acontecendo, volte e jogue!',
                        'relatório',
                        'Você precisa terminar o game para ver o seu resultado',
                    ],
                    comingSoon:[
                        'Reagendar',
                        'Sessão agendada para',
                        ' às ',
                        'horário de brasilia',
                        'Entrar',
                        'O jogo estará disponivel às',
                        'do dia',
                        'relatório',
                        'Você precisa terminar o game para ver o seu resultado',
                        
                    ],
                    notScheduled:[
                        'Agendar',
                        'Agende a sua sessão para ter acesso ao game. :)',
                        'entrar',
                        'Agende a sua sessão para ter acesso ao game. :)',
                        'relatório',
                        'Você precisa terminar o game para ver o seu resultado',
                    ],
                    report:[
                        'Concluido',
                        'Você não pode reagendar após ter finalizado o game.',
                        'Concluido',
                        'Você não pode mais jogar após ter finalizado o game.',
                        'relatório',
                        'O seu relatório foi processado. Você já pode visualiza-lo.'
                    ]
                } 
            },
            Feedback360:{
                title: 'Quem mais contribuiu com o grupo?',
                descTitle: 'Selecione da maior para menor contribuição.',
                selectPodium: ['Selecione o ', ' lugar'],
                clearForm: 'limpar',
                evaluate: 'Avaliar',
                alertInfo:{
                    title: 'Pera aí!',
                    subtitle: 'Você precisa avaliar os membros do seu grupo para acessar o resultado do seu game'
                }
            },
            FinalEquation:{
                back: 'Voltar',
                valueWarning: ['Lembre-se de responder apenas com números! Cada tentativa ','tem o custo de $1.000'],
                inputFinalEquation: 'Digite a resposta final',
                buttonSendFinalEquation: 'Enviar',
                titleAttempts: 'tentativas anteriores',
                toasterWarnings: ['Resposta vazia', 'Dinheiro insuficiente', 'Tentativa repetida', 'Tentativa enviada'],
            },
            WaitingRoom:{
                title: 'Aguardando o inicio do Game ...'
            },
            feedback:{
                Experience:{
                    body: ['Como foi a sua','experiencia no game?'],
                    acceptanceContact: 'Autorizo que a Huddle entre em contato e me mantenha atualizade de futuras novidades',
                    experienceStatusDesc: ['Excelente', 'Muito Boa', 'Regular','Ruim','Péssima']
                },
                Explain:{
                    body: [
                        'Você teve algum problema? Se sim, expecifique-o.', 
                        'Em que parte aconteceu? Como aconteceu? Você conseguiu resolver?',
                        'Algo inesperado aconteceu durante o game? Entre em contato conosco clicando no botão abaixo.'
                    ],
                    buttonText: 'Enviar Feedback'
                },
                Finish:{
                    body: ['Concluir', 'Feedback Enviado', 'Gratidão','Obrigado por jogar o Decode Game. Esperamos que tenha curtido a experiência. :)']
                },
                Gift:{
                    body: [
                        'Que', 
                        'tal presentear algum RH', 
                        'com créditos para utilizar a Huddle em seus processo seletivos?','insira os dados da(o) presenteada(o):'
                    ],
                    options: [
                        'Não conheço ninguém que atua com RH para presentar :(',
                        'Quero presentear alguém que trabalha em um RH!'
                    ],
                    labelsPlaceholder: ['Nome', 'Empresa','E-mail','Telefone']
                },
                Preference:{
                    body:[
                        'Você prefere modelos de avaliação em processo seletivo como esse',
                        'game ou modelos tradicionais?'
                    ],
                    optionsTexts:[
                        'Prefiro modelos como esse que participei agora (games).',
                        'Prefiro modelos convencionais, como testes de lógica.',
                        'Prefiro modelos onde respondo sobre mim e obtenho meu perfil.',
                    ]
                },
                Problem:{
                    body:[
                        'Quais',
                        'tipos de problema',
                        'você teve?'
                    ],
                    optionsTexts:[
                        'Dei comando na plataforma que não apareceram no game (pedir pistas, enviar respostas, etc).' ,
                        'Tive problemas em me comunicar com outros participantes.',
                        'Tive problemas com a minha conexão, ou com meu dispositivo e afins',
                        'Durante o jogo, tive problemas com os enigmas.',
                        'O game terminou antes do tempo demonstrado para mim.'
                    ]
                }
            }
        },
        Chat:{
            newPlayerMessage: 'entrou no grupo',
        },
        Sections:{
            HeaderChat: {
                back: 'Voltar' 
            },
            HeaderDefault: {
                help: 'Ajuda' 
            },
            HeaderGame: {
                back: 'Grupo', 
                rules: 'Regras',
                help: 'Ajuda' 
            }
        },
        Shared:{
            IconHeader:{
                finalEquation: 'Equação Final'
            }
        }
    },
    'en-US': {
        store: {
            rulesVideoUrl: '<iframe width="250px" height="auto" src="https://www.youtube.com/embed/ES20X5GqfKg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'        
        }
    },
    'es': {
        store: {
            rulesVideoUrl: '<iframe width="250px" height="auto" src="https://www.youtube.com/embed/ES20X5GqfKg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        }
    },
};

const i18n = new VueI18n({
    locale: 'pt-BR', // set locale
    fallbackLocale: 'pt-BR', // set fallback locale
    messages: languages // set locale messages
});

export default i18n;